import PollWidgetView from './PollWidgetView.vue';

export const type = 'poll';
export const view = PollWidgetView;

export function builder() {
  return {
    type,
    name: 'Poll name (for segment)',
    color: 'black',
    options: ['||', '||', '||', '||', '||'],
    selectedOption: null,
    pollAnswer: null,
    isOpinionPoll: false,
    showNumbers: true,
    top: 20,
  };
}
